import React, { Component } from 'react';

import "./Mentor.scss"


class Mentor extends Component {
  constructor(props) {
    super();
    this.state = {
      item: {
        backgroundImage: "url(" + props.mentor.imageURL + ")"
      },
      itemMobile: {
        backgroundImage: (window.screen.width < 1000 ? "url(" + props.mentor.imageURL + ")" : "")
      }
    }
  }
  render() {
    return (
      <li>
        <div className="item" style={this.state.itemMobile} onClick={this.props.onMentorClick}>
          <div className="item-bio">
          <div className="item-bio-name">
          {this.props.mentor.name}
          </div>
          <div className="item-bio-title">
          {this.props.mentor.title}
          </div>
          </div>
            <div className="item-fadeblue" style={this.state.item}></div>
        </div>
        </li>
    );
  }
}

export default Mentor;



// WEBPACK FOOTER //
// ./src/components/Mentors/components/Mentor/Mentor.js